const BASE_URL = "https://api.hyperliquid.xyz/info";

async function postRequest(body) {
  const res = await fetch(BASE_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });

  if (!res.ok) {
    throw new Error(`HTTP error: ${res.status}`);
  }

  return res.json();
}

export async function fetchMetaAndCtxs(dex) {
  return postRequest({
    type: "metaAndAssetCtxs",
    ...(dex ? { dex } : {}),
  });
}

export async function fetchAllPerpMetas() {
  return postRequest({
    type: "allPerpMetas",
  });
}

export async function fetchOutcomeMeta() {
  return postRequest({
    type: "outcomeMeta",
  });
}

export async function fetchspotMeta() {
  return postRequest({
    type: "spotMeta",
  });
}


export async function fetchPerpCategories() {
  return postRequest({
    type: "perpCategories",
  });
}